import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const carlitoApiQueryClient = new QueryClient();

export const CarlitoApiClientProvider: React.FC = ({ children }) => {
  return (
    <QueryClientProvider client={carlitoApiQueryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
